import { message } from 'antd'
import Employees from '../../../../../api/Employees'
import Members from '../../../../../api/Members'
import LabourContracts from '../../../../../api/People/LabourContracts'
import Templates from '../../../../../api/Templates'
import _, { get, isEmpty, omit, pick } from 'lodash'
import { arrVal, checkForm, strVal } from '../../../../../modules/Utils'
import omitEmpty from 'omit-empty'
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import AddContract from './AddContract'

class AddContractCont extends Component {
  constructor(props) {
    super(props)
    let contract = get(props.location, 'state.contract') || {}
    let entitlements = contract.entitlements || {}
    this.templateApi = new Templates()
    this.memberApi = new Members()
    this.contractApi = new LabourContracts()
    this.api = new Employees()

    contract = omit(get(props.location, 'state.contract') || {}, 'entitlements')
    this.state = {
      submitting: false,
      memberFetching: true,
      contract: Object.assign({}, contract, {
        annual: arrVal(entitlements, 'annual'),
        compassionate: arrVal(entitlements, 'compassionate'),
        hospitalisation: arrVal(entitlements, 'hospitalisation'),
        medical: arrVal(entitlements, 'medical'),
        parental: arrVal(entitlements, 'parental'),
        rollover: entitlements.rollover || {},
        medicalOptions: entitlements.medicalOptions || { reimbursable: false },
      }),
      member: get(props.location, 'state.member') || {},
      employee: get(props.location, 'state.employee') || {},
      showSkip: false,
      current: 0,
      id: props.match.params.key,
      contractKey: get(props.match, 'params.contractKey'),
      type: get(props.match, 'params.contractKey') ? 'update' : 'new',
      api: new Employees(),
      memberApi: new Members(),
    }
  }

  async componentDidMount() {
    if (this.state.type !== 'update') {
      this.setState({
        fetchingContacts: true,
      })
      // auto fill date when "new" contract
      const contactsResponse = await this.memberApi.contacts.get(this.state.id)
      const contacts = await contactsResponse.json()
      this.setState({
        fetchingContacts: false,
        contract: Object.assign({}, this.state.contract, {
          employee: {
            address: (contacts.address || []).find((c) => c.default === true),
            phone: (contacts.phone || []).find((c) => c.default === true),
            email: (contacts.email || []).find((c) => c.default === true),
            mobile: (contacts.mobile || []).find((c) => c.default === true),
          },
        }),
      })
    }
    if (isEmpty(this.state.member)) {
      try {
        this.setState({
          memberFetching: true,
        })

        const employeeResponse = await this.api.getMember(this.state.id)
        let employee = await employeeResponse.json()

        const memberResponse = await this.memberApi.get(this.state.id)
        let member = await memberResponse.json()
        let contract = this.state.contract
        if (this.state.contractKey) {
          contract = await this.contractApi.get(this.state.contractKey)
          // let entitlements = contract.entitlements || {}
          // contract = omit(contract || {}, 'entitlements')
          // contract = Object.assign({}, contract, {
          //   annual: entitlements.annual || [],
          //   compassionate: entitlements.compassionate || [],
          //   hospitalisation: entitlements.hospitalisation || [],
          //   medical: entitlements.medical || [],
          //   parental: entitlements.parental || [],
          //   rollover: entitlements.rollover || {},
          //   medicalOptions: entitlements.medicalOptions || {
          //     reimbursable: false,
          //   },
          // })
        }

        this.setState({
          member,
          employee,
          contract,
          memberFetching: false,
          employeeFetching: false,
        })
      } catch (error) {
        console.error(error)
        message.error(error.errorMessage)
        this.setState({
          memberFetching: false,
          employeeFetching: false,
        })
      }
    } else {
      this.setState({ memberFetching: false })
    }
  }

  contractRef = React.createRef()
  updateContract = (attribute, value) => {
    const { contract } = this.state
    this.setState({
      contract: Object.assign({}, contract, { [attribute]: value }),
    })
  }
  updateContractRollover = (attribute, value) => {
    const contract = this.state.contract
    const rollover = this.state.contract.rollover
    let newRollover = Object.assign({}, rollover, { [attribute]: value })
    this.setState({
      contract: Object.assign({}, contract, { rollover: newRollover }),
    })
  }
  updateContractMedicalOptions = (value) => {
    const contract = this.state.contract
    this.setState({
      contract: Object.assign({}, contract, { medicalOptions: value }),
    })
  }
  submit = async (valid = true) => {
    let data = await checkForm(this.contractRef)

    data.date = {
      effective: data.date.effective.format('YYYY-MM-DD'),
      start: data.date.start.format('YYYY-MM-DD'),
      expiry: data.date.expiry && data.date.expiry.format('YYYY-MM-DD'),
      probation: data.date.probation.format('YYYY-MM-DD'),
    }

    this.setState({ submitting: true })
    const { contract } = this.state
    try {
      data = _.set(
        data,
        'entitlements',
        pick(contract, [
          'annual',
          'compassionate',
          'hospitalisation',
          'medical',
          'parental',
          'rollover',
          'medicalOptions',
        ])
      )

      data = _.set(data, 'employee._id', this.state.employee._id)

      data = omitEmpty(data)
      await this.contractApi.create(data)
      this.props.history.replace({
        pathname: `/people/member/${this.state.id}/`,
        hash: 'contracts',
      })
    } catch (error) {
      console.error(error)
      message.error(error.errorMessage)
    }
    this.setState({ submitting: false })
  }
  fetchEntitlementsTemplate = async () => {
    const { annual, compassionate, hospitalisation, medical, parental } = this.state.contract
    if (
      isEmpty(annual) &&
      isEmpty(compassionate) &&
      isEmpty(hospitalisation) &&
      isEmpty(medical) &&
      isEmpty(parental)
    ) {
      try {
        this.setState({ fetchingEntitlements: true })
        const companyID = strVal(this.state, 'contract.company._id').replace('members/', '')
        let employeeTemplate = await this.templateApi.read(companyID, 'employee')
        let entitlements = employeeTemplate['entitlements'] || {}
        let contract = this.state.contract
        contract = omit(contract || {}, 'entitlements')
        contract = Object.assign({}, contract, {
          annual: entitlements.annual || [],
          compassionate: entitlements.compassionate || [],
          hospitalisation: entitlements.hospitalisation || [],
          medical: entitlements.medical || [],
          parental: entitlements.parental || [],
          rollover: entitlements.rollover || {},
          medicalOptions: entitlements.medicalOptions || { reimbursable: false },
        })
        this.setState({ contract, fetchingEntitlements: false })
      } catch (error) {
        console.error(error)
        message.error(error.errorMessage)
        this.setState({
          fetchingEntitlements: false,
        })
      }
    }
  }
  update = async (valid = true) => {
    let data = await checkForm(this.contractRef)
    data.date = {
      effective: data.date.effective.format('YYYY-MM-DD'),
      start: data.date.start.format('YYYY-MM-DD'),
      expiry: data.date.expiry && data.date.expiry.format('YYYY-MM-DD'),
      probation: data.date.probation.format('YYYY-MM-DD'),
    }

    if (valid) {
      this.setState({ submitting: true })
      try {
        let { contract } = this.state

        data = _.set(
          data,
          'entitlements',
          pick(contract, [
            'annual',
            'compassionate',
            'hospitalisation',
            'medical',
            'parental',
            'rollover',
            'medicalOptions',
          ])
        )

        data = { ...data, ...contract }

        data = omit(data, [
          'code',
          'status',
          'state',
          'workOrders',
          '_history',
          'owner',
          'annual',
          'compassionate',
          'hospitalisation',
          'medical',
          'parental',
          'rollover',
          'medicalOptions',
        ])
        data = _.set(data, 'employee._id', this.state.employee._id)
        data = _.set(data, '_id', this.state.contractKey)

        data = omitEmpty(data)
        await this.contractApi.update(data)
        this.props.history.replace({
          pathname: `/people/member/${this.state.id}/contracts/${this.state.contractKey}/view`,
        })
      } catch (error) {
        console.error(error)
        message.error(error.errorMessage)
      }
      this.setState({ submitting: false })
    }
  }
  // checkOverviewForm = () => {
  //   return new Promise((res, rej) => {
  //     this.overviewCmpRef.current.validateFieldsAndScroll((err, values) => {
  //       if (!err) {
  //         this.setState({
  //           contract: Object.assign({}, this.state.contract, values),
  //         })
  //         res(true)
  //       } else {
  //         const values = this.overviewCmpRef.current.getFieldsValue()
  //         this.setState({
  //           contract: Object.assign({}, this.state.contract, values),
  //         })
  //       }
  //     })
  //   })
  // }
  // checkKeyTermsForm = () => {
  //   return new Promise((res, rej) => {
  //     this.keyTermsCmpRef.current.validateFieldsAndScroll((err, values) => {
  //       if (!err) {
  //         let date = {
  //           effective: values.date.effective.format('YYYY-MM-DD'),
  //           start: values.date.start.format('YYYY-MM-DD'),
  //           expiry:
  //             values.date.expiry && values.date.expiry.format('YYYY-MM-DD'),
  //           probation: values.date.probation.format('YYYY-MM-DD'),
  //         }
  //         this.setState({
  //           contract: Object.assign({}, this.state.contract, {date}),
  //         })
  //         res(true)
  //       }
  //     })
  //   })
  // }
  // checkStatutoryForm = () => {
  //   return new Promise((res, rej) => {
  //     if (isEmpty(this.state.contract.statutory)) {
  //       message.error("Statutory details can't be empty")
  //       return rej(false)
  //     }
  //     res(true)
  //   })
  // }
  // checkPayrollForm = () => {
  //   return new Promise((res, rej) => {
  //     this.payrollCmpRef.current.validateFieldsAndScroll((err, values) => {
  //       if (!err) {
  //         if (isEmpty(this.state.contract.rates)) {
  //           message.error("Rates details can't be empty")
  //           return rej(false)
  //         }
  //         this.setState({
  //           contract: Object.assign({}, this.state.contract, values),
  //         })
  //         res(true)
  //       } else {
  //         const values = this.payrollCmpRef.current.getFieldsValue()
  //         this.setState({
  //           contract: Object.assign({}, this.state.contract, values),
  //         })
  //       }
  //     })
  //   })
  // }
  // checkCommunicationForm = () => {
  //   return new Promise((res, rej) => {
  //     this.communicationCmpRef.current.validateFieldsAndScroll(
  //       (err, values) => {
  //         if (!err) {
  //           this.setState({
  //             contract: Object.assign({}, this.state.contract, values),
  //           })
  //           res(true)
  //         } else {
  //           const values = this.communicationCmpRef.current.getFieldsValue()
  //           this.setState({
  //             contract: Object.assign({}, this.state.contract, values),
  //           })
  //         }
  //       },
  //     )
  //   })
  // }

  render() {
    return (
      <AddContract
        {...this.state}
        {...pick(this, [
          'updateContract',
          'updateContractRollover',
          'updateContractMedicalOptions',
          'prev',
          'next',
          'skip',
          'submit',
          'member',
          'update',
          'contract',
          'fetchEntitlementsTemplate',
          'checkOverviewForm',
          'checkKeyTermsForm',
          'checkStatutoryForm',
          'checkPayrollForm',
          'checkCommunicationForm',
          'memberFetching',
          'submitting',
          'employee',
          'contractRef',
          'fetchingContacts',
          'medicalOptions',
        ])}
      />
    )
  }
}

AddContractCont.propTypes = {}
AddContractCont.defaultProps = {}

export default withRouter(AddContractCont)
